const countries = {
    'US': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/US-flag._V192206995_.gif',
        name: 'United States',
        storeUrl: 'https://amazon.com',
        isEnabled: true,
    },
    'GB': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/UK-flag._V192206995_.gif',
        name: 'United Kingdom',
        storeUrl: 'https://amazon.co.uk',
        isEnabled: true,
    },
    'DE': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/DE-flag._V192206995_.gif',
        name: 'Germany',
        storeUrl: 'https://amazon.de',
        isEnabled: true,
    },
    'FR': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/FR-flag._V192206995_.gif',
        name: 'France',
        storeUrl: 'https://amazon.fr',
        isEnabled: true,
    },
    'ES': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/ES-flag._V192206995_.gif',
        name: 'Spain',
        storeUrl: 'https://amazon.es',
        isEnabled: true,
    },
    'CA': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/CA-flag._V192206995_.gif',
        name: 'Canada',
        storeUrl: 'https://amazon.ca',
        isEnabled: true,
    },
    'AU': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/AU-flag._V192206995_.gif',
        name: 'Australia',
        storeUrl: 'https://amazon.com.au',
        isEnabled: true,
    },
    'IT': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/IT-flag._V192206995_.gif',
        name: 'Italy',
        storeUrl: 'https://amazon.it',
        isEnabled: false,
    },
    'NL': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/NL-flag._V192206995_.gif',
        name: 'Netherlands',
        storeUrl: 'https://amazon.nl',
        isEnabled: false,
    },
    'IN': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/IN-flag._V192206995_.gif',
        name: 'India',
        storeUrl: 'https://amazon.in',
        isEnabled: true,
    },
    'BR': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/BR-flag._V192206995_.gif',
        name: 'Brazil',
        storeUrl: 'https://amazon.com.br',
        isEnabled: true,
    },
    'MX': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/MX-flag._V192206995_.gif',
        name: 'Mexico',
        storeUrl: 'https://amazon.com.mx',
        isEnabled: true,
    },
    'UAE': {
        flagUrl: 'https://images-eu.ssl-images-amazon.com/images/G/39/associates/network/UAEFlag._CB1198675309_.png',
        name: 'United Arab Emirates',
        storeUrl: 'https://amazon.ae',
        isEnabled: true,
    },
    'JP': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/JP-flag._V192206995_.gif',
        name: 'Japan',
        storeUrl: 'https://amazon.co.jp',
        isEnabled: false,
    },
    'CN': {
        flagUrl: 'https://images-na.ssl-images-amazon.com/images/G/01/associates/network/CN-flag._V192206995_.gif',
        name: 'China',
        storeUrl: 'https://amazon.cn',
        isEnabled: false,
    },
};

module.exports = countries;